import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth-context";
import { AdminTabs } from "../components/admin/AdminTabs";
import { AvailabilityPlanner } from "../components/admin/availability/AvailabilityPlanner";
import { AvailabilityCsvButton } from "../components/admin/AvailabilityCsvButton";

const ConsultantTabs = ({ list, active, onPick }) => (
  <div className="flex flex-wrap gap-2" role="tablist">
    {list.map((c) => (
      <button key={c.slug} type="button" role="tab" aria-selected={active === c.slug} onClick={() => onPick(c.slug)}
        data-testid={`availability-tab-${c.slug}`}
        className={`px-4 py-2 rounded-full border text-sm transition-colors ${active === c.slug ? "bg-bronze-dark text-white border-bronze-dark" : "border-bronze-light/60 text-bronze-dark hover:bg-cream-100"}`}>
        {c.name}
      </button>
    ))}
  </div>
);

export default function AdminAvailability() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/availability").then(({ data }) => { setData(data); setActive(data.consultants[0]?.slug); })
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, []);

  const saved = (rule) => setData((d) => ({ ...d, consultants: d.consultants.map((c) => (c.slug === rule.slug ? rule : c)) }));
  const rule = data?.consultants.find((c) => c.slug === active);
  const pick = (slug) => {
    if (slug !== active && document.querySelector('[data-testid="availability-dirty"]')?.textContent.startsWith("You have") && !window.confirm("You have unsaved changes for this consultant. Switch anyway?")) return;
    setActive(slug);
  };

  return (
    <div data-testid="admin-availability-page" className="container-ccc py-12">
      <div className="eyebrow">Admin · {user?.email}</div>
      <h1 className="font-serif text-4xl mt-2">Availability</h1>
      <AdminTabs active="/admin/availability" />
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <p className="text-sm text-ink-muted max-w-2xl">
          Patients can book from {data?.min_notice_days || 7} days ahead. Changes apply to the booking page within a minute.
          Times already booked are never removed.
        </p>
        <AvailabilityCsvButton />
      </div>
      {error && <div className="mt-6 text-sm text-destructive" data-testid="admin-availability-error">{error}</div>}
      {!data && !error && <div className="mt-10 text-ink-muted">Loading…</div>}
      {data && (
        <div className="mt-8 space-y-6">
          <ConsultantTabs list={data.consultants} active={active} onPick={pick} />
          {rule && <AvailabilityPlanner key={rule.slug} rule={rule} minNoticeDays={data.min_notice_days || 7} onSaved={saved} />}
        </div>
      )}
    </div>
  );
}
